import type { UUID } from "utils";

/*eslint perfectionist/sort-objects: "error"*/
export const TEST_IDS = {
  activeInfo: "active-info",
  activeInfoResetButton: "active-info-reset-button",
  bannerResetPasswordButton: "banner-reset-password-button",
  cannotDisableTwoFAInfo: "cannot-disable-two-fa-info",
  configurationBreadcrumbLink: "configuration-breadcrumb-link",
  customerAutocomplete: "user-customer",
  customerCard: "user-customer-card",
  customerError: "user-customer-error",
  customerInput: "user-customer-input",
  customerName: "user-customer-name",
  demoteUserFromOwnerFailureToast: "demote-user-from-owner-failure-toast-id",
  demoteUserFromOwnerSuccessToast: "demote-user-from-owner-success-toast-id",
  editButton: "edit-button",
  email: "email",
  filterButton: "users-filters-filters-button",
  filters: {
    content: "users-filters-content",
    customerFilter: "users-filters-customer-id",
    getUserTypeFilterOption: (option: string) =>
      `${option}-users-filters-user-type-filter-option`,
    permissions: "users-filters-permissions",
    permissionsCondition: "users-filters-permissions-condition",
    userTypeFilter: "users-filters-user-type",
    userTypeFilterTagSelect: "users-filters-user-type-filter-tag-select",
  },
  filtersPrefix: "users-filters",
  getUserRow: (id: UUID) => `user-id-${id}`,
  id: "id",
  lastSuccessfulLoginDate: "last-successful-login-date",
  lastSuccessfulLoginSection: "last-successful-login-section",
  name: "name",
  notFoundBreadcrumbLink: "user-not-found-breadcrumb-link",
  passwordResetFailureToast: "password-reset-failure-toast-id",
  passwordResetSuccessToast: "password-reset-success-toast-id",
  promoteToOwnerFailureToast: "promote-to-owner-failure-toast-id",
  promoteToOwnerSuccessToast: "promote-to-owner-success-toast-id",
  resetButton: "reset-button",
  scaButton: "sca-button",
  scaInfo: "sca-info",
  scaRemovalFailureToast: "sca-removal-failure-toast-id",
  scaRemovalSuccessToast: "sca-removal-success-toast-id",
  scaSection: "sca-section",
  twoFAButton: "2fa-button",
  twoFAInfo: "2fa-info",
  userAddButton: "user-add-button",
  userCreateFailureToast: "user-create-toast-id",
  userCreateSuccessToast: "user-create-toast-id",
  userDetailsBreadcrumbLink: "user-details-breadcrumb-link",
  userEditFailureToast: "user-edit-toast-id",
  userEditSuccessToast: "user-edit-toast-id",
  userEmail: "user-email",
  userFormValidationFailureToast: "user-form-validation-failure-toast-id",
  userName: "user-name",
  userPermissionsCardWrapper: "user-permissions-section",
  usersBreadcrumbLink: "users-breadcrumb-link",
  userToggle: "switch-label",
  userTypeOwner: "user-type-owner",
  userTypeOwnerTooltip: "user-type-owner-tooltip",
  userTypeSection: "user-type-section",
  userTypeStandardUser: "user-type-standard-user",
  userTypeVoltAdmin: "user-type-volt-admin",
  userVoltEmployeeCheckbox: "user-volt-employee-checkbox",
  userVoltEmployeeControlTile: "user-volt-employee-control-tile",
} as const;
